import request from "@utils/request";

export function getSecurity(query) {
    return request({
        url: 'security',
        method: 'get',
        params: query
    })
}